export default __webpack_public_path__ + "static/media/CEDIA-recoleccion-aguaje.2569fcf4.jpg";